import { Outlet, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import { useHistory } from "../context/HistoryContext";
import { useEffect } from "react";
import ConnectivityHandler from "../components/portal/ConnectivityHandler";
import { InterventionInputProvider } from "../context/InterventionInputContext";

const Layout : React.FC = () => {
    const { push } = useHistory();
    const location = useLocation();

    useEffect(() => {
        push(location.pathname);
    }, [location]);

    return (
        <main className="min-h-[100dvh]">
            <Toaster richColors/>

            <ConnectivityHandler />

            <InterventionInputProvider>
                <Outlet />
            </InterventionInputProvider>

        </main>
    )
}

export default Layout;